import {
  FETCH,
  DONE,
  FAIL,
  LESSON,
  VIEW,
  ONE,
  ADD,
  GET,
  LIST,
  EDIT,
  CTP,
  TEST,
  ANSWER,
  INNER,
  CONTENT,
  DELETE,
  RESULT,
  TASK,
  SET,
  MATERIAL,
  PLAN, CURRENT, BEGIN, IMPORT, LIBRARY, PROCTORING, RESET, FILTER, EXAM
} from "../../constants";

import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import dayjs from "dayjs";
import {END} from "redux-saga";

const initialState = {
  oneCtp: {
    ...reducerStatuses,
    data: null as any
  },
  list: {...reducerStatuses, data: null as any},
  filter: {...reducerStatuses, data: null as any},
  listCurrent: {...reducerStatuses, data: null as any},
  lessons: {
    ...reducerStatuses,
    data: null as any,
  },
  oneLesson: {
    ...reducerStatuses,
    data: null as any,
  },
  oneTest: {
    ...reducerStatuses,
    data: null as any,
  },
  testResult: {
    ...reducerStatuses,
    data: null as any,
  },
  testImportFromLibrary: {
    ...reducerStatuses,
    data: null as any,
  },
  proctoringResult: {
    ...reducerStatuses,
    data: null as any,
  },
  oneTask: {
    ...reducerStatuses,
    data: null as any,
  },
  examStatement: {
    ...reducerStatuses,
    data: null as any,
  }
};

export default createReducer(initialState, builder =>
  builder
    .addCase(RESET + PLAN, (state, {payload}: PayloadAction<any>) => ({
      ...initialState
    }))


    .addCase(GET + CTP + VIEW + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneCtp: {
        ...initialState.oneCtp,
        loading: true,
      },
    }))
    .addCase(GET + CTP + VIEW + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneCtp: {
        ...initialState.oneCtp,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + CTP + VIEW + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneCtp: {
        ...initialState.oneCtp,
        failed: true,
      },
    }))

    .addCase(GET + PLAN + LIST + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      list: {
        ...initialState.list,
        loading: true
      },
    }))
    .addCase(GET + PLAN + LIST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      list: {
        ...initialState.list,
        success: true,
        data: payload
      },
    }))
    .addCase(GET + PLAN + LIST + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      list: {
        ...initialState.list,
        failed: true,
      },
    }))

    .addCase(GET + PLAN + CURRENT + FILTER + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      filter: {
        ...initialState.filter,
        loading: true
      },
    }))
    .addCase(GET + PLAN + CURRENT + FILTER + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      filter: {
        ...initialState.filter,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + PLAN + CURRENT + FILTER + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      filter: {
        ...initialState.filter,
        failed: true,
      },
    }))

    .addCase(GET + PLAN + CURRENT + CTP + LIST + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      listCurrent: {
        ...initialState.listCurrent,
        loading: true
      },
    }))
    .addCase(GET + PLAN + CURRENT + CTP + LIST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      listCurrent: {
        ...initialState.listCurrent,
        success: true,
        data: payload
      },
    }))
    .addCase(GET + PLAN + CURRENT + CTP + LIST + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      listCurrent: {
        ...initialState.listCurrent,
        failed: true,
      },
    }))

    .addCase(LESSON + VIEW + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      lessons: {
        ...initialState.lessons,
        loading: true,
      },
    }))
    .addCase(LESSON + VIEW + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      lessons: {
        ...initialState.lessons,
        success: true,
        data: payload,
      },
    }))
    .addCase(LESSON + VIEW + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      lessons: {
        ...initialState.lessons,
        failed: true,
      },
    }))


    .addCase(LESSON + VIEW + ONE + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneLesson: {
        ...initialState.oneLesson,
        loading: true
      },
    }))
    .addCase(LESSON + VIEW + ONE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneLesson: {
        ...initialState.oneLesson,
        success: true,
        data: payload,
      },
    }))
    .addCase(LESSON + VIEW + ONE + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneLesson: {
        ...initialState.oneLesson,
        failed: true,
      },
    }))


    .addCase(LESSON + ADD + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      lessons: {
        ...state.lessons,
        loading: true,
        success: false,
      },
    }))
    .addCase(LESSON + ADD + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
      let newItem = {
        id: payload.data.id,
        date: `${payload.data.date} 00:00:00`,
        title: `${dayjs(payload.data.date).format('DD.MM')} - ${payload.data.theme}`,
        filter: null,
        isEdit: true,
        isDelete: true
      }

      return {
        ...state,
        lessons: {
          ...state.lessons,
          loading: false,
          success: true,
          data: [
            ...state.lessons.data, newItem
          ]
        }
      }
    })


    .addCase(LESSON + ONE + ADD + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneLesson: {
        ...state.oneLesson,
        loading: true,
        success: false,
      },
    }))
    .addCase(LESSON + ONE + ADD + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
      let newItem = {
        ...payload.data,
        created_at: dayjs(),
        updated_at: dayjs(),
      }

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: false,
          success: true,
          data: {
            ...state.oneLesson.data,
            [payload.data.currentTab]: [...state.oneLesson.data[payload.data.currentTab], newItem]
          }
        }
      }
    })
    .addCase(LESSON + EDIT + FETCH, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneCtp: {
          ...state.oneCtp,
          loading: true,
          success: false,
        },
        oneLesson: {
          ...state.oneLesson,
          loading: true,
          success: false,
        }
      }
    })
    .addCase(LESSON + EDIT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneCtp: {
          ...state.oneCtp,
          loading: false,
          success: true,
          data: state.oneCtp?.data
        },
        oneLesson: {
          ...state.oneLesson,
          loading: false,
          success: true,
          data: state.oneLesson?.data
        }
      }
    })


    .addCase(GET + TEST + ANSWER + FETCH, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneTest: {
          ...initialState.oneTest,
          loading: true,
        }
      }
    })
    .addCase(GET + TEST + ANSWER + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneTest: {
          ...state.oneTest,
          loading: false,
          success: true,
          data: payload
        }
      }
    })

    .addCase(GET + TEST + ANSWER + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneTest: {
          ...initialState.oneTest,
          failed: true,
        }
      }
    })

    // .addCase(ADD + TEST + ANSWER + FETCH, (state, {payload}: PayloadAction<any>) => {
    //   return {
    //     ...state,
    //     oneTest: {
    //       ...state.oneTest,
    //       success: true,
    //       loading: true,
    //     }
    //   }
    // })
    //
    .addCase(ADD + TEST + ANSWER + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneTest: {
          ...initialState.oneTest,
          success: true,
          data: {
            ...state.oneTest.data,
            questions: payload.questions
          }
        }
      }
    })

    .addCase(EDIT + INNER + CONTENT + FETCH, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: true,
          success: false,
          data: {
            ...state.oneLesson.data,
          }
        }
      }
    })
    .addCase(EDIT + INNER + CONTENT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: false,
          success: true,
          data: {
            ...state.oneLesson.data,
            [payload.data.currentTab]: state.oneLesson.data[payload.data.currentTab].map((item: any) => {
              if (item.id == payload.data.id) {
                return {
                  ...payload.data,
                  updated_at: dayjs()
                }
              } else {
                return item
              }
            })
          }
        }
      }
    })

    .addCase(EDIT + INNER + CONTENT + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...initialState.oneLesson,
          failed: true,
          data: {
            ...state.oneLesson.data,
          }
        }
      }
    })


    .addCase(DELETE + INNER + CONTENT + FETCH, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: true,
          success: false,
          data: {
            ...state.oneLesson.data,
          }
        }
      }
    })
    .addCase(DELETE + INNER + CONTENT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: false,
          success: true,
          data: {
            ...state.oneLesson.data,
            [payload.data.currentTab]: state.oneLesson.data[payload.data.currentTab].filter((item: any) => item.id !== payload.data.id)
          }
        }
      }
    })

    .addCase(TEST + BEGIN + FETCH, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        testResult: {
          ...initialState.testResult,
          loading: true,
        }
      }
    })

    .addCase(TEST + BEGIN + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        testResult: {
          ...initialState.testResult,
          success: true,
          data: payload.data
        }
      }
    })

    .addCase(TEST + BEGIN + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        testResult: {
          ...initialState.testResult,
          failed: true,
        }
      }
    })

    .addCase(TEST + RESULT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
      return {
        ...state,
        testResult: {
          ...initialState.testResult,
          success: true,
          data: {
            ...state.testResult.data,
            act: 'answer',
            question: state.testResult.data.question?.map((item: any, index: number) => {
              if(item.id === payload.id){
                return {
                  ...item,
                  answers: item.answers.map((answer: any) => {
                    let isAnswer = payload.answers.some((answerInner: any) => answer.id === answerInner.id)

                    return {
                      ...answer,
                      isAnswer: isAnswer
                    }
                  })
                }
              } else {
                return item
              }
            })
          }
        }
      }
    })

    .addCase(TEST + END + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
      return {
        ...state,
        testResult: {
          ...initialState.testResult,
          success: true,
          data: {
            ...state.testResult.data,
            act: 'finish',
          }
        }
      }
    })



    .addCase(TASK + RESULT + SET + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: true
        },
      }
    })

    .addCase(MATERIAL + RESULT + SET + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {

      return {
        ...state,
        oneLesson: {
          ...state.oneLesson,
          loading: true
        },
      }
    })


    .addCase(TEST + IMPORT + LIBRARY + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testImportFromLibrary: {
        ...initialState.testImportFromLibrary,
        loading: true
      },
    }))
    .addCase(TEST + IMPORT + LIBRARY + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testImportFromLibrary: {
        ...initialState.testImportFromLibrary,
        success: true,
        data: payload,
      },
    }))
    .addCase(TEST + IMPORT + LIBRARY + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testImportFromLibrary: {
        ...initialState.testImportFromLibrary,
        failed: true,
      },
    }))

    .addCase(GET + PROCTORING + RESULT + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      proctoringResult: {
        ...initialState.proctoringResult,
        loading: true
      },
    }))
    .addCase(GET + PROCTORING + RESULT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      proctoringResult: {
        ...initialState.proctoringResult,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + PROCTORING + RESULT + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      proctoringResult: {
        ...initialState.proctoringResult,
        failed: true,
      },
    }))

    .addCase(GET + TASK + ONE + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneTask: {
        ...initialState.oneTask,
        loading: true
      },
    }))
    .addCase(GET + TASK + ONE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneTask: {
        ...initialState.oneTask,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + TASK + ONE + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneTask: {
        ...initialState.oneTask,
        failed: true,
      },
    }))

    .addCase(GET + EXAM + ONE + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      examStatement: {
        ...initialState.examStatement,
        loading: true
      },
    }))
    .addCase(GET + EXAM + ONE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      examStatement: {
        ...initialState.examStatement,
        success: true,
        data: payload,
      },
    }))
    .addCase(GET + EXAM + ONE + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      examStatement: {
        ...initialState.examStatement,
        failed: true,
      },
    }))
)
